import { render, staticRenderFns } from "./BrandCampaign.page.vue?vue&type=template&id=2f8a7aa6&"
import script from "./BrandCampaign.page.vue?vue&type=script&lang=js&"
export * from "./BrandCampaign.page.vue?vue&type=script&lang=js&"
import style0 from "./BrandCampaign.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports